import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex items-start space-x-3" }
const _hoisted_2 = { class: "flex-shrink-0" }
const _hoisted_3 = { class: "h-10 w-10 rounded-full bg-blue-600 flex items-center justify-center text-white" }
const _hoisted_4 = { class: "flex-1 min-w-0" }
const _hoisted_5 = { class: "flex justify-between items-baseline" }
const _hoisted_6 = { class: "text-white font-medium truncate" }
const _hoisted_7 = { class: "text-xs text-gray-400" }
const _hoisted_8 = { class: "text-gray-300 text-xs truncate mt-1" }
const _hoisted_9 = { class: "text-gray-300 text-sm truncate mt-1" }
const _hoisted_10 = {
  key: 0,
  class: "mt-2 flex justify-end"
}
const _hoisted_11 = { class: "bg-blue-600 text-white text-xs rounded-full px-2 py-1 min-w-5 text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["conversation-item p-4 hover:bg-gray-700 cursor-pointer transition-colors relative group", { 'bg-gray-700': _ctx.isActive }]),
    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('click')))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.userInitials), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.conversation.otherUser.username), 1),
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.formatDate(_ctx.conversation.lastMessage.createdAt)), 1)
        ]),
        _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.conversation.product.name), 1),
        _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.conversation.lastMessage.content), 1)
      ])
    ]),
    (_ctx.conversation.unreadCount > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.conversation.unreadCount), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('delete')), ["stop"])),
      class: "absolute right-2 top-2 opacity-0 group-hover:opacity-100 transition-opacity p-1 bg-red-600 text-white rounded hover:bg-red-700",
      title: "Obriši konverzaciju"
    }, _cache[2] || (_cache[2] = [
      _createElementVNode("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, [
        _createElementVNode("polyline", { points: "3 6 5 6 21 6" }),
        _createElementVNode("path", { d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" })
      ], -1)
    ]))
  ], 2))
}